module.exports = __webpack_public_path__ + "media/mixkit-old-telephone-ring-1357.28a1532e.wav";